import React, { useState } from "react";
import { LabelPadrao, ModalPadrao } from "../../components/Base";
import { BtnPadrao, BtnSair } from "../../components/Buttons";
import SelectPesq from "../../components/Selects/SelectPesq";
import SelectPesqProduto from "../../components/Selects/SelectPesqProduto";
import Mensagens from "../../components/Mensagens";
import TabelaPadrao from "../../components/TabelaPadrao";
import InputBlur from "../../components/InputBlur";
import roundCustom from "../../Utils/RoundCustom";

export default function ModalServico({ visible, onOk, onCancel, online }) {
  const [prestadorServico, setPrestadorServico] = useState([]);
  const [servicos, setServicos] = useState([]);

  const columns = [
    {
      Header: "Descrição",
      accessor: "descricao",
      Cell: props => <span>{props.row.original.codigo} - {props.row.original.descricao}</span>
    },
    {
      Header: "Prestador de serviço",
      accessor: "prestadorId",
      Cell: props => !!props.row.original.prestadorId?.length ? <span>{props.row.original.prestadorId[0].codigo} - {props.row.original.prestadorId[0].nome}</span> : <></>
    },
    {
      Header: "Quantidade",
      accessor: "qtd",
      Cell: props => <InputBlur min={0.01} type="number" value={props.row.original.qtd} onChange={v => {
        const aux = [...servicos];
        aux[props.row.index].qtd = v;
        aux[props.row.index].valorTotal = roundCustom(aux[props.row.index].valorUn * v);
        setServicos(aux);
      }} />,

    },
  ];

  return <ModalPadrao title="Serviço" style={{ minHeight: 400 }} width={500} visible={visible} onCancel={onCancel} footer={<>
    <BtnPadrao onClick={() => { onOk(servicos); setServicos([]); setPrestadorServico([]); }}>Incluir</BtnPadrao>
    <BtnSair onClick={onCancel} />
  </ >}>

    <SelectPesq title="Prestador de serviço" modelo="prestadorservico" value={prestadorServico.prestadorId} onChange={v => setPrestadorServico({ ...prestadorServico, prestadorId: v })} tabIndex={100} placeholder="Pesquisar prestador de serviço" maxTagTextLength={30} noMargin />

    <LabelPadrao>Código\Descrição</LabelPadrao>
    <SelectPesqProduto tabIndex={101} nextTab={101} onChange={(serv, qtd) => {
      const aux = [...servicos];

      const inx = servicos.findIndex(x => x.id == serv.id);

      if (inx >= 0)
        aux[inx].qtd += qtd;
      else
        aux.push({ ...serv, prestadorId: prestadorServico?.prestadorId, qtd, valorUn: serv.preco, valorTotal: roundCustom(serv.preco * qtd), desconto: 0, descPorc: 0, isServico: true });

      setServicos(aux);
    }} online={online} tipo="servico" />

    <TabelaPadrao style={{ marginTop: 25 }} columns={columns} data={servicos} onDelete={serv => {
      const aux = [...servicos];
      aux.splice(aux.findIndex(x => x.id == serv.id), 1);
      setServicos(aux);
    }} />
  </ModalPadrao>;
}

